<template lang="html">
  <div class="container-pad">
    <apply-now-banner />
    <apply-now-main-section />
  </div>
</template>

<script>

import ApplyNowBanner from './components/ApplyNowBanner';
import ApplyNowMainSection from './components/ApplyNowMainSection';

export default {
  name: 'ApplyNow',
  props: {
  },
  components: {
    'apply-now-banner': ApplyNowBanner,
    'apply-now-main-section': ApplyNowMainSection,
  },
  data() {
    return {
    };
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
  },
  methods: {
    jumpToForm() {
      const element = document.getElementById('rare-contact-form');
      const y = element.getBoundingClientRect().top + (window.pageYOffset - 330);

      const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

      if (isIE11 === true) {
        document.getElementById('validationAnchor').scrollIntoView();
      } else {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.container-pad {
  padding-top: 20px;
}

@media only screen and (max-width: 800px)  {
  .container-pad {
    padding-top: 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/applyNow/applyNow.vue